import React, { useState, useEffect } from 'react';

const AddProductVariantModal = ({ 
  isOpen, 
  onClose, 
  variantAttributes, 
  selectedVariants, 
  toggleVariantValue, 
  isVariantValueSelected,
  generateVariants
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] flex flex-col">
        {/* Modal Header */}
        <div className="flex justify-between items-center px-6 py-4 border-b border-gray-200">
          <h3 className="text-lg font-medium text-gray-900">Configuration des variantes</h3>
          <button 
            type="button" 
            className="text-gray-400 hover:text-gray-500" 
            onClick={onClose}
          >
            <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        {/* Modal Body - Scrollable */}
        <div className="flex-1 overflow-y-auto p-6">
          <div className="mb-6">
            <p className="text-sm text-gray-500">
              Sélectionnez les valeurs des attributs pour générer des variantes de produit.
            </p>
          </div>
          
          <div className="divide-y divide-gray-200">
            {variantAttributes.map((attribute) => (
              <div key={attribute.id} className="py-5">
                <div className="mb-4 flex justify-between items-center">
                  <h5 className="text-sm font-medium text-gray-900">
                    {attribute.name}
                  </h5>
                </div>
                
                <div className="pl-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                  {attribute.values && attribute.values.map((value) => (
                    <div key={value.id} className="flex items-center">
                      <input
                        id={`modal-value-${attribute.id}-${value.id}`}
                        type="checkbox"
                        className="h-4 w-4 text-[#174540] focus:ring-[#174540] border-gray-300 rounded"
                        checked={isVariantValueSelected(attribute.id, value.id)}
                        onChange={() => toggleVariantValue(attribute.id, value.id)}
                      />
                      <label 
                        htmlFor={`modal-value-${attribute.id}-${value.id}`} 
                        className="ml-2 block text-sm text-gray-700 w-full"
                      >
                        {value.value}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
        
        {/* Modal Footer */}
        <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex items-center justify-between">
          <div className="text-sm text-gray-500">
            <span className="font-medium">{selectedVariants.length}</span> valeurs sélectionnées
          </div>
          <div className="flex space-x-3">
            <button
              type="button"
              className="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#174540]"
              onClick={onClose}
            >
              Annuler
            </button>
            <button
              type="button"
              className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#174540] hover:bg-[#0d2926] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#174540]"
              disabled={selectedVariants.length === 0}
              onClick={() => {
                generateVariants();
                onClose();
              }}
            >
              Générer les variantes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddProductVariantModal;